module.exports = __webpack_public_path__ + "fonts/MD5.09d73afb.eot";